import { render, staticRenderFns } from "./InitQuestionnaire.vue?vue&type=template&id=a7873258&scoped=true&"
import script from "./InitQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./InitQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./InitQuestionnaire.vue?vue&type=style&index=0&id=a7873258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7873258",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VTextField,VTextarea})
